module.exports = __webpack_public_path__ + "img/8.a93ba71d.png";